export default {
    ACTIVITY_ACTIVE_CALORIES: 'ACTIVITY_ACTIVE_CALORIES',
    ACTIVITY_AVERAGE_SPEED: 'ACTIVITY_AVERAGE_SPEED',
    ACTIVITY_AVERAGE_PACE: 'ACTIVITY_AVERAGE_PACE',
    ACTIVITY_AVERAGE_SWIM_PACE: 'ACTIVITY_AVERAGE_SWIM_PACE',
    ACTIVITY_AVERAGE_HEART_RATE: 'ACTIVITY_AVERAGE_HEART_RATE',
    ACTIVITY_MAX_HEART_RATE: 'ACTIVITY_MAX_HEART_RATE',
    ACTIVITY_AVERAGE_POWER: 'ACTIVITY_AVERAGE_POWER',
    ACTIVITY_AVERAGE_BIKE_CADENCE: 'ACTIVITY_AVERAGE_BIKE_CADENCE',
    ACTIVITY_AVERAGE_RUN_CADENCE: 'ACTIVITY_AVERAGE_RUN_CADENCE',
    ACTIVITY_NORMALIZED_POWER: 'ACTIVITY_NORMALIZED_POWER',
    ACTIVITY_MAX_20_MIN_AVERAGE_POWER: 'ACTIVITY_MAX_20_MIN_AVERAGE_POWER',
    ACTIVITY_VERTICAL_OSCILLATION: 'ACTIVITY_VERTICAL_OSCILLATION',
    ACTIVITY_GROUND_CONTACT_TIME: 'ACTIVITY_GROUND_CONTACT_TIME',
    ACTIVITY_AVERAGE_STROKES: 'ACTIVITY_AVERAGE_STROKES',
    ACTIVITY_AVERAGE_SWOLF: 'ACTIVITY_AVERAGE_SWOLF',
    ACTIVITY_MINIMUM_SWOLF: 'ACTIVITY_MINIMUM_SWOLF',
    ACTIVITY_NUMBER_OF_ACTIVITIES: 'ACTIVITY_NUMBER_OF_ACTIVITIES',
    ACTIVITY_TOTAL_DISTANCE: 'ACTIVITY_TOTAL_DISTANCE',
    ACTIVITY_TOTAL_DURATION: 'ACTIVITY_TOTAL_DURATION',
    ACTIVITY_TRAINING_STRESS_SCORE: 'ACTIVITY_TRAINING_STRESS_SCORE',
    ACTIVITY_VO2_MAX: 'ACTIVITY_VO2_MAX',
    ACTIVITY_VO2_MAX_CYCLING: 'ACTIVITY_VO2_MAX_CYCLING',
    ACTIVITY_AVG_GROUND_CONTACT_BALANCE: 'ACTIVITY_AVG_GROUND_CONTACT_BALANCE',
    ACTIVITY_AVG_STRIDE_LENGTH: 'ACTIVITY_AVG_STRIDE_LENGTH',
    ACTIVITY_AVG_VERTICAL_RATIO: 'ACTIVITY_AVG_VERTICAL_RATIO',
    ACTIVITY_AVG_LACTATE_THRESHOLD_BPM: 'ACTIVITY_AVG_LACTATE_THRESHOLD_BPM',
    ACTIVITY_AVG_LT_SPEED_MTR_PER_SEC: 'ACTIVITY_AVG_LT_SPEED_MTR_PER_SEC',
    COMMON_TOTAL_CALORIES: 'COMMON_TOTAL_CALORIES',
    WELLNESS_TOTAL_STEPS: 'WELLNESS_TOTAL_STEPS',
    WELLNESS_TOTAL_PUSHES: 'WELLNESS_TOTAL_PUSHES',
    SLEEP_SLEEP_DURATION: 'SLEEP_SLEEP_DURATION',
    SLEEP_SLEEP_SCORE: 'SLEEP_SLEEP_SCORE',
    FOOD_CALORIES_CONSUMED: 'FOOD_CALORIES_CONSUMED',
    ACTIVITY_MAX_FTP: 'ACTIVITY_MAX_FTP',
    FOOD_CALORIES_REMAINING: 'FOOD_CALORIES_REMAINING',
    WELLNESS_FLOORS_ASCENDED: 'WELLNESS_FLOORS_ASCENDED',
    WELLNESS_MODERATE_INTENSITY_MINUTES: 'WELLNESS_MODERATE_INTENSITY_MINUTES',
    WELLNESS_RESTING_HEART_RATE: 'WELLNESS_RESTING_HEART_RATE',
    ACTIVITY_AEROBIC_TRAINING_EFFECT: 'ACTIVITY_AEROBIC_TRAINING_EFFECT',
    ACTIVITY_ANAEROBIC_TRAINING_EFFECT: 'ACTIVITY_ANAEROBIC_TRAINING_EFFECT',
    ACTIVITY_AEROBIC_TRAINING_EFFECT_CYCLING: 'ACTIVITY_AEROBIC_TRAINING_EFFECT_CYCLING',
    ACTIVITY_ANAEROBIC_TRAINING_EFFECT_CYCLING: 'ACTIVITY_ANAEROBIC_TRAINING_EFFECT_CYCLING',
    WELLNESS_AVERAGE_STRESS: 'WELLNESS_AVERAGE_STRESS',
    ACTIVITY_TRAINING_STATUS: 'ACTIVITY_TRAINING_STATUS',
    ACTIVITY_TRAINING_STATUS_CYCLING: 'ACTIVITY_TRAINING_STATUS_CYCLING',
    ACTIVITY_HRV_STRESS_TEST: 'ACTIVITY_HRV_STRESS_TEST',
    STRENGTH_TRAINING: 'STRENGTH_TRAINING',
    PILATES: 'PILATES',
    MOBILITY: 'MOBILITY',
    WELLNESS_BODYBATTERY_CHARGED: 'WELLNESS_BODYBATTERY_CHARGED',
    WELLNESS_BODYBATTERY_DRAINED: 'WELLNESS_BODYBATTERY_DRAINED',
    OUTDOOR_PULSE_OX_ACCLIMATION: 'OUTDOOR_PULSE_OX_ACCLIMATION',
    ACTIVITY_POWER_CURVE_CYCLING: 'ACTIVITY_POWER_CURVE_CYCLING',
    WELLNESS_HYDRATION: 'WELLNESS_HYDRATION',
    MENSTRUAL_CYCLE_TRACKING_REPORTS: 'MENSTRUAL_CYCLE_TRACKING_REPORTS',
    ALL_DAY_PULSE_OX: 'ALL_DAY_PULSE_OX',
    ALL_DAY_RESPIRATION: 'ALL_DAY_RESPIRATION',
    ACTIVITY_AVERAGE_RESPIRATION_RATE: 'ACTIVITY_AVERAGE_RESPIRATION_RATE',
    ACTIVITY_TOTAL_DURATION_WITH_FILTERING: 'ACTIVITY_TOTAL_DURATION_WITH_FILTERING',
    REPORTS_AVERAGE_SWIM_PACE: 'REPORTS_AVERAGE_SWIM_PACE',
    REPORTS_AVERAGE_CYCLING_PACE: 'REPORTS_AVERAGE_CYCLING_PACE',
    REPORTS_AVERAGE_RUNNING_PACE: 'REPORTS_AVERAGE_RUNNING_PACE',
    REPORTS_AVERAGE_CYCLING_SPEED: 'REPORTS_AVERAGE_CYCLING_SPEED',
    REPORTS_AVERAGE_RUNNING_SPEED: 'REPORTS_AVERAGE_RUNNING_SPEED',
    PREGNANCY_TRACKING_REPORTS: 'PREGNANCY_TRACKING_REPORTS',
    FITNESS_AGE: 'FITNESS_AGE',
    ACTIVITY_RACE_PREDICTOR_TRENDS: 'ACTIVITY_RACE_PREDICTOR_TRENDS',
    ACTIVITY_HRV_STATUS: 'ACTIVITY_HRV_STATUS',
    FTP_CYCLING: 'FTP_CYCLING',
    FTP_XC_SKI: 'FTP_XC_SKI',
    CRITICAL_SWIM_SPEED: 'CRITICAL_SWIM_SPEED',
    ACTIVITY_AVERAGE_WHEELCHAIR_PUSH_CADENCE: 'ACTIVITY_AVERAGE_WHEELCHAIR_PUSH_CADENCE',
    ACTIVITY_TOTAL_ELEVATION_GAIN: 'ACTIVITY_TOTAL_ELEVATION_GAIN',
    REPORTS_RUNNING_LACTATE_THRESHOLD: 'REPORTS_RUNNING_LACTATE_THRESHOLD',
    ENDURANCE_SCORE: 'ENDURANCE_SCORE',
    HILL_SCORE: 'HILL_SCORE',
    GAMING_WIN_RATE: 'GAMING_WIN_RATE',
    GAMING_STRESS: 'GAMING_STRESS',
    GAMING_BODY_BATTERY: 'GAMING_BODY_BATTERY',
    RUNNING_TOLERANCE: 'RUNNING_TOLERANCE',
    RUNNING_ECONOMY: 'RUNNING_ECONOMY',
    PACK_WEIGHT: 'PACK_WEIGHT',
    ACTIVITY_AVG_STEP_SPEED_LOSS: 'ACTIVITY_AVG_STEP_SPEED_LOSS',
    ACTIVITY_AVG_STEP_SPEED_LOSS_PERCENT: 'ACTIVITY_AVG_STEP_SPEED_LOSS_PERCENT'
};
